module.exports = __webpack_public_path__ + "images/b425a562b438585cd58bb4afe710b766.jpg";